import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR, ReactiveFormsModule
} from '@angular/forms'
import {TranslateService} from "@ngx-translate/core";
import {debounceTime, Subscription} from "rxjs";
import {CoreModule} from "../../../../../core.module";


@Component({
    selector: 'app-input-only-number[name]',
    templateUrl: './input-only-number.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useClass: InputOnlyNumberComponent,
            multi: true
        }],
    imports: [CoreModule, ReactiveFormsModule],
    standalone: true
})
export class InputOnlyNumberComponent implements ControlValueAccessor , OnInit, OnDestroy {

  @Input() public name!: string
  @Input() public minValue: number | null = null;
  @Input() public maxValue: number | null = null;
  @Input() public customClasses = '';

  @ViewChild(FormControlDirective, {static: true})
  public formControlDirective?: FormControlDirective;

  @Input()
  public formControl!: FormControl<number>

  @Input()
  public formControlName!: string;

  private formValueChangeSubscription?: Subscription;

  public get control(): FormControl<number | null> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <FormControl<number | null>>this.formControl ?? this.controlContainer.control.get(this.formControlName);
  }

  get controlContainer(): ControlContainer {
    return this.injector.get(ControlContainer);
  }

  registerOnTouched(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: number | null): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(): void {
    // da formControl und control identisch sind brauchen wir hier nichts weiter zu geben

  }

  constructor(private readonly cdr: ChangeDetectorRef, private readonly injector: Injector, private translate: TranslateService) {
  }

  public ngOnInit(): void {
    this.checkValueRestrictions(this.formControl?.value)
    this.formValueChangeSubscription = this.control.valueChanges.pipe(debounceTime(250)).subscribe({
      next: value => {
        this.checkValueRestrictions(value);
      }
    });
  }

  public ngOnDestroy() {
    this.formValueChangeSubscription?.unsubscribe();
  }

  private checkValueRestrictions(value: number | null) {
    if(value === null) {
      this.control?.setValue(this.minValue ?? 1);
    }
    if(this.minValue && this.maxValue && this.minValue > this.maxValue) {
      this.control?.setValue(0);
      return;
    }
    if(this.minValue && value && value < this.minValue) {
      this.control?.setValue(this.minValue);
      return;
    }
    if(this.maxValue && value && value > this.maxValue) {
      this.control?.setValue(this.maxValue);
      return;
    }
  }
}
